// test2071
(2071 && 0);
